import { FC } from 'react'
import { Stack } from 'rsuite'
import { GiEarthAsiaOceania } from 'react-icons/gi'
import DashCard from '../../atoms/dashCard/DashCard'
import './dashCards.scss'

type CardData = {
  title: string,
  description: string | React.ReactNode,
  icon: string | JSX.Element | React.ReactNode,
  route: string
}

type Props = {
  data: CardData[],
  onCardClick?: (route: string) => void
}

const DashCards: FC<Props> = ({ data, onCardClick }: Props) => {
  const renderIcon = (
    icon: string | JSX.Element | React.ReactNode | undefined
  ) => {
    if (!icon) {
      return <GiEarthAsiaOceania color="green" size={35} />
    }
    if (typeof icon === 'object' && 'type' in icon) {
      return icon
    }

    if (typeof icon === 'string') {
      return icon
    }

    return <GiEarthAsiaOceania color="green" size={35} />
  }
  const renderTitle = (title: string | undefined) => {
    if (!title) {
      return '-'
    }
    if (title === '') {
      return '-'
    }
    return title
  }
  return (
    <Stack
      spacing={15}
      justifyContent="space-between"
      alignItems="stretch"
      className="dash-cards"
    >
      {data.map(({ title, description, icon, route }) => (
        <DashCard
          key={title}
          title={renderTitle(title)}
          description={description ?? '-'}
          icon={renderIcon(icon)}
          onClick={() => onCardClick?.(route)}
        />
      ))}
    </Stack>
  )
}

export default DashCards
